var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreRegistrationCheckedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check-In",
    transform: "translate(16099 -18815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9595",
    "data-name": "Rectangle 9595",
    width: 24,
    height: 24,
    transform: "translate(-16099 18815)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-In-2",
    "data-name": "Check-In",
    d: "M4.066,24a.377.377,0,0,1-.116-.014.6.6,0,0,1-.285-.131.362.362,0,0,1-.083-.083.532.532,0,0,1-.127-.237.489.489,0,0,1-.026-.179V15.429H4.8a2.056,2.056,0,0,0,3.408,1.408l3.758-3.289a2.058,2.058,0,0,0,0-3.1L8.212,7.162A2.056,2.056,0,0,0,4.805,8.571H3.429V.637A.5.5,0,0,1,3.462.45a.55.55,0,0,1,.15-.258A.415.415,0,0,1,3.706.116S3.714.109,3.727.1L3.74.094A.3.3,0,0,1,3.867.034.373.373,0,0,1,3.947.011.68.68,0,0,1,4.066,0h17.1A.638.638,0,0,1,21.8.637V23.362a.638.638,0,0,1-.637.637ZM7.97,1.28l8.358,2.152a.354.354,0,0,1,.266.341V19.949a.352.352,0,0,1-.259.341L7.663,22.721H20.524V1.279H7.97Zm5.373,9.636V12.81a.356.356,0,1,0,.713,0V10.916a.356.356,0,1,0-.713,0ZM6.171,15.289V14.057H1a1,1,0,0,1-1-1V10.942a1,1,0,0,1,1-1H6.171V8.711a.69.69,0,0,1,.69-.687.668.668,0,0,1,.447.171l.5.437.022.019,2.967,2.6.019.018.251.219a.686.686,0,0,1,0,1.032L7.309,15.8a.673.673,0,0,1-.447.171A.69.69,0,0,1,6.171,15.289Z",
    transform: "translate(-16098 18815)",
    fill: "#637381"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreRegistrationCheckedInIcon);
export default __webpack_public_path__ + "static/media/PreRegistrationCheckedInIcon.ed02076647b7746f480adcba53846bd2.svg";
export { ForwardRef as ReactComponent };